import { EndpointsE } from "../data/endpoints";
import getURIString from "../utils/helpers/auth/getURIStringFromObj";
import { jumboMediaAPI } from "./service";

import type {
  ForgotPasswordByEmailPayloadT,
  ForgotPasswordByEmailResultT,
  ForgotPasswordByUserNamePayloadT,
  ForgotPasswordByUserNameResultT,
  ResetUserPasswordPayloadT,
  ResetUserPasswordResultT,
} from "./models/models";

export const loginAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({
        url: EndpointsE.TOKEN,
        method: "POST",
        body: getURIString(body),
        validateStatus: (response, result) =>
          response.status === 500 ? (result.errorstatus = 500) : result,
      }),
    }),
    forgotPasswordByUserName: build.mutation<
      ForgotPasswordByUserNameResultT,
      ForgotPasswordByUserNamePayloadT
    >({
      query: (body) => {
        return {
          url: `/api/Account/ReactForgotPasswordByUsername?username=${body.username}`,
          method: "POST",
        };
      },
    }),
    forgotPasswordByEmail: build.mutation<
      ForgotPasswordByEmailResultT,
      ForgotPasswordByEmailPayloadT
    >({
      query: (body) => {
        return {
          url: `/api/Account/ReactForgotPasswordByEmail?email=${body.email}`,
          method: "POST",
        };
      },
    }),
    resetUserPassword: build.mutation<
      ResetUserPasswordResultT,
      ResetUserPasswordPayloadT
    >({
      query: (body) => ({
        url: `/api/Account/ResetUserPassword`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useForgotPasswordByEmailMutation,
  useForgotPasswordByUserNameMutation,
  useResetUserPasswordMutation,
} = loginAPI;
